export const DOCUFORMS_TAB_SECTIONS = [
  {id: 'client', name: 'client.matters.matter_page.docuforms_tab.client_submissions'},
  {id: 'business', name: 'client.matters.matter_page.docuforms_tab.sent_to_client'},
  {id: 'internal', name: 'client.matters.matter_page.docuforms_tab.added_internally'}
]
